export default __webpack_public_path__ + "static/media/harrison-bw.928aa7b7.jpeg";